import type React from "react";
import type { ExtendedOption } from "../../../../../formkit";
import {
  type FormProps,
  type JsonColumnProps,
  MappingType,
  type VariableScope,
} from "src/formkit/components/types";
import { ArrayInput } from "./array-input";
import { ObjectInput } from "./object-input";
import { StandardInput } from "./standard-input";
import { StaticInput } from "./static-input";
import { TemplateInput } from "./template-input";
import { VariableInput } from "./variable-input";

export const INPUTS: Record<
  // Reference mappings use AssociationMapper, and spread mappings use the
  // dedicated spread sub-section (not the per-row type picker), so omit both.
  Exclude<MappingType, MappingType.REFERENCE | MappingType.SPREAD>,
  // Just the call signature rather than `FC`: under @types/react 18.3, `FC`'s
  // `propTypes` no longer unifies with the `forwardRef` components stored here
  // (e.g. `StandardInput`), and JSX only needs the component to be callable.
  (
    props: FormProps & {
      scope: VariableScope;
      enableInLineMapper?: boolean;
      jsonColumnProperties: JsonColumnProps;
      onClose: () => void;
      ref: React.Ref<HTMLInputElement>;
      selectedOption: ExtendedOption | undefined;
    },
  ) => React.ReactNode
> = {
  [MappingType.BOOSTED]: StandardInput,
  [MappingType.STANDARD]: StandardInput,
  [MappingType.STATIC]: StaticInput,
  [MappingType.VARIABLE]: VariableInput,
  [MappingType.TEMPLATE]: TemplateInput,
  [MappingType.OBJECT]: ObjectInput,
  [MappingType.ARRAY]: ArrayInput,
};

export type GetIsValidProps = {
  errors: any;
  index?: number;
  mappingDirection: "from" | "lookup.by" | "lookup.from" | "to";
  mappingName: string;
};
